import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import { ContactsContextProvider as ContactsProvider } from 'contexts/ContactsContext';

// pages
const ServiceTable = Loadable(lazy(() => import('pages/services/serviceTable')));
const UserRolesTable = Loadable(lazy(() => import('pages/config/userRolesTable')));

// ==============================|| APPS ROUTING ||============================== //

const ConfigRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <ContactsProvider>
          <MainLayout />
        </ContactsProvider>
      ),
      children: [
        {
          path: 'config',
          children: [
            {
              path: 'services',
              element: <ServiceTable />
            },
            {
              path: 'users',
              element: <UserRolesTable />
            }
          ]
        }
      ]
    }
  ]
};

export default ConfigRoutes;
